import React from 'react';
import PropTypes from 'prop-types';
import Spinner from './Spinner';
import styled from 'styled-components';
import { Button } from 'shards-react';
import { Consumer as LoadingConsumer } from '../../../contexts/LoadingContext';

const SubmitButton = ({ children, loading }) => (
  <ButtonFillParent theme="outline-secondary" type="submit">
    <LoadingConsumer>
      {(contextLoading) =>
        (loading ?? contextLoading) ? (
          <Spinner />
        ) : (
          children || (
            <em className="material-icons" style={{ fontSize: 25 }}>
              search
            </em>
          )
        )
      }
    </LoadingConsumer>
  </ButtonFillParent>
);

SubmitButton.propTypes = {
  children: PropTypes.node,
  loading: PropTypes.bool
};

const ButtonFillParent = styled(Button)`
  && {
    padding: 0;
  }
`;

export default SubmitButton;
